import clearUserTokens from "./clearUserTokens";

function authPopupWindow(url, title, win, w, h) {
  const y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
  const x = win.top.outerWidth / 2 + win.top.screenX - w / 2;
  return win.open(
    url,
    title,
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, titlebar=no, width=${w}, height=${h}, top=${y}, left=${x}`
  );
}

export default function redirectToHpa(
  hpaUrl,
  baseUrl,
  destination,
  setAuthInProgress
) {
  clearUserTokens();
  // const endpoint = destination === "register" ? "" : "sign-in";
  const port = window.location.port === "" ? "" : `:${window.location.port}`;
  const callback = `${window.location.protocol}//${window.location.hostname}${port}${window.location.pathname}`;
  const redirect = `${baseUrl}/authorize/`;
  const stringify = btoa(JSON.stringify({ callback_uri: callback }));

  if (
    window.navigator.userAgent.indexOf("Trident/7.0") > -1 ||
    /Edge/.test(window.navigator.userAgent)
  ) {
    window.location.replace(
      `${hpaUrl}/account/sign-in?redirect_uri=${redirect}&remember_me=false&state=${stringify}`
    );
  } else {
    const child = authPopupWindow(
      `${hpaUrl}/account/sign-in?redirect_uri=${redirect}&remember_me=false&state=${stringify}`,
      "hstream",
      window,
      600,
      600
    );

    const timer = setInterval(() => {
      if (child.closed) {
        clearInterval(timer);
        setAuthInProgress(false);
      }
    }, 200);

    window.addEventListener("focus", () => {
      child.focus();
      window.addEventListener(
        "click",
        () => {
          child.close();
        },
        {
          once: true
        }
      );
    });
  }
}
